/** Routing hints never grant access. Keep this tiny: the bootstrap is public. */
export function miniAppPath(param: string | undefined): string | null {
  if (!param || !/^[A-Za-z0-9_-]{1,512}$/.test(param)) return null;
  if (param === "my") return "/account";
  if (/^club_[a-z0-9-]+$/.test(param)) return `/teams/${param.slice(5)}`;
  // Double underscore separates slugs/ids, both of which may contain hyphens.
  const hub = /^hub_([a-z0-9-]+)__([A-Za-z0-9-]+)(?:__(spirit|roster))?$/.exec(param);
  return hub ? `/t/${hub[1]}/team/${hub[2]}${hub[3] ? `/${hub[3]}` : ""}` : null;
}

/**
 * A squad's pickup invite link opened inside Telegram (2026-09-15):
 * `pk<keyId><secret>`, the token without its dot. The key id is always 12
 * characters (`newKeyId`), which is what makes the dot recoverable, as for an
 * invitation's `i…`. A routing hint like the rest: the secret is verified by
 * the Worker, and the page it lands on (`/pickup-invite`) keeps the token in
 * memory only.
 */
const PICKUP_START = "pk";
const PICKUP_KEY_ID_WIDTH = 12;

export function pickupStartParam(token: string): string | null {
  const dot = token.indexOf(".");
  if (dot !== PICKUP_KEY_ID_WIDTH || token.indexOf(".", dot + 1) >= 0) return null;
  const param = `${PICKUP_START}${token.slice(0, dot)}${token.slice(dot + 1)}`;
  return /^[A-Za-z0-9_-]{1,64}$/.test(param) ? param : null;
}

export function pickupTokenOfStartParam(param: string | undefined): string | null {
  // 2 + 12 + a 22-character secret at the least, 64 in all (Telegram's cap).
  if (!param || !/^pk[A-Za-z0-9_-]{34,62}$/.test(param)) return null;
  const at = PICKUP_START.length + PICKUP_KEY_ID_WIDTH;
  return `${param.slice(PICKUP_START.length, at)}.${param.slice(at)}`;
}
